export class AssertionError extends Error {
	public override readonly name = "AssertionError";
	public readonly code = "ERR_ASSERTION";
}
